import { Box, FormControl, InputAdornment, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import {ReactNode} from "react";

interface Props {
    disabled?: boolean;
    placeholder?: string;
    variant?: "standard" | "outlined" | "filled";
    icon?: ReactNode;
    title?: string;
    selectOptions?: any[];
    name: string;
    defaultValue?: string;
    value?: string;
    required?: boolean;
    onChange: (value: any) => void;
}

function SelectField({ disabled, placeholder, variant, icon, title, selectOptions, name, defaultValue, value, required, onChange }: Props) {
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <Box>
            {title && (
                <Typography variant="body2" gutterBottom>
                    {title}
                </Typography>
            )}
            <FormControl disabled={disabled} fullWidth>
                <Select
                    required={required}
                    variant={variant}
                    startAdornment={
                        icon &&
                            <InputAdornment
                                
                                position="start"
                            >
                                {icon}
                            </InputAdornment>
                    }
                    displayEmpty={true}
                    name={name}
                    defaultValue={defaultValue}
                    value={value}
                    onChange={handleSelectChange}
                    sx={{
                        backgroundColor: 'background.paper',
                    }}
                    MenuProps={{
                        slotProps: {
                            paper: {
                                sx: {
                                    borderRadius: "8px",
                                    backgroundColor: 'background.paper',
                                },
                            },
                        },
                    }}
                >
                    <MenuItem value={""}>
                            <Typography variant="body2">{placeholder}</Typography>
                    </MenuItem>
                    {selectOptions?.map((option) => (
                        <MenuItem key={option} value={option}>
                            <Typography variant="body2">{option}</Typography>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}

export default SelectField;
